<main class="main-home-secton">
  <div class="event-main">
    <div class="container-fluid">
      <div class="event-details-div">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <mat-card class="new-card">
              <div class="row">
                <div class="col-lg-8 col-md-6 col-sm-12">
                  <div class="incubator-detail-div" style="margin-left: 2%">
                    <h1 style="color: #253b80">{{ projectView.name }}</h1>
                  </div>
                </div>
                <div class="col-lg-2 col-md-6 col-sm-12" style="float: right">
                  <div class="m-2" align="center">
                    <button
                      class="intrest-btn"
                      (click)="intrestbtn(projectView.id)"
                    >
                      I am Interested
                    </button>
                  </div>

                  <div id="interestSuccess" class="modal">
                    <div class="modal-content text-center">
                      <p>
                        Thank you for showing interest on the project. You will
                        hear from us soon.
                      </p>
                      <div class="text-center">
                        <button
                          class="incubatorBtn"
                          (click)="closeModalInterestSuccess()"
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  </div>
                  <div id="interestNotified" class="modal">
                    <div class="modal-content text-center">
                      <p>Your Interest has been already Notified.</p>
                      <div class="text-center">
                        <button
                          class="incubatorBtn"
                          (click)="closeModalInterestNotified()"
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <div class="col-lg-12 col-md-12 col-sm-12 title-head">
                  <p class="sub-title">PROJECT DETAILS</p>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head">Project Name : </span
                          ><span class="details-list">
                            {{ projectView.name }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head">Sub Sector : </span
                          ><span class="details-list">
                            {{ projectView.projectSector }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head"
                            >Year of Completion : </span
                          ><span class="details-list">
                            {{ projectView.completionYear }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head">Districts : </span
                          ><span class="details-list">
                            {{ projectView.districts }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head">Taluks : </span
                          ><span class="details-list">
                            {{ projectView.taluks }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head">Budget : </span
                          ><span class="details-list">
                            {{ projectView.budget }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head"
                            >Outcome Of Project : </span
                          ><span class="details-list">
                            {{ projectView.projectOutCome }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <mat-card class="new-card">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 title-head">
                  <p class="sub-title">ORGANIZATION DETAILS</p>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head"
                            >Organization Name : </span
                          ><span class="details-list">
                            {{ projectView.organizationName }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head"
                            >Year of Incorporation : </span
                          ><span class="details-list">
                            {{ projectView.inCropYear }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head"
                            >Darpan Registration Number : </span
                          ><span class="details-list">
                            {{ projectView.dropRegNo }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head"
                            >Registered address : </span
                          ><span class="details-list">
                            {{ projectView.regAddr }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12">
            <mat-card class="new-card">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 title-head">
                  <p class="sub-title">CEO/DIRECTOR NAME</p>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head">CEO Name : </span
                          ><span class="details-list">
                            {{ projectView.name }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head">CEO Email : </span
                          ><span class="details-list">
                            {{ projectView.email }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head">CEO Mobile : </span
                          ><span class="details-list">
                            {{ projectView.mobile }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12">
            <mat-card class="new-card">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 title-head">
                  <p class="sub-title">SPOC DETAILS</p>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head">SPOC Name : </span
                          ><span class="details-list">
                            {{ projectView.spocName }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head">SPOC Email : </span
                          ><span class="details-list">
                            {{ projectView.spocEmail }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div class="incubator-detail-div">
                    <div class="d-flex">
                      <div class="ml-3">
                        <p class="detail-p">
                          <span class="detail-side-head">SPOC Mobile : </span
                          ><span class="details-list">
                            {{ projectView.spocMobile }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12">
            <mat-card class="new-card">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 title-head">
                  <p class="sub-title">Document Details</p>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <mat-card class="doc-card">
                    <div class="incubator-detail-div">
                      <div class="d-flex align-items-center doc-card-cont">
                        <div class="ml-3">
                          <p class="detail-p">Incorparation Document</p>
                        </div>
                        <div class="ml-auto" (click)="incorpDocu()">
                          <div *ngIf="incorpdownloadUrl">
                            <img
                              src="assets\images\doc-download-image.png"
                              alt="Image"
                              class="image-right"
                            />
                          </div>
                          <div *ngIf="!incorpdownloadUrl">
                            <img
                              style="cursor: not-allowed"
                              src="assets\images\doc-download-cancel.png"
                              alt="Image"
                              class="image-right"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <mat-card class="doc-card">
                    <div class="incubator-detail-div">
                      <div class="d-flex align-items-center doc-card-cont">
                        <div class="ml-3">
                          <p class="detail-p">12AA and 80G Document</p>
                        </div>
                        <div class="ml-auto" (click)="twlaa80gDoc()">
                          <div *ngIf="tweldocumentUrl">
                            <img
                              src="assets\images\doc-download-image.png"
                              alt="Image"
                              class="image-right"
                            />
                          </div>
                          <div *ngIf="!tweldocumentUrl">
                            <img
                              style="cursor: not-allowed"
                              src="assets\images\doc-download-cancel.png"
                              alt="Image"
                              class="image-right"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <mat-card class="doc-card">
                    <div class="incubator-detail-div">
                      <div class="d-flex align-items-center doc-card-cont">
                        <div class="ml-3">
                          <p class="detail-p">Plan of ProjectDocument</p>
                        </div>
                        <div class="ml-auto" (click)="actionDocu()">
                          <div *ngIf="actiondocumentUrl">
                            <img
                              src="assets\images\doc-download-image.png"
                              alt="Image"
                              class="image-right"
                            />
                          </div>
                          <div *ngIf="!actiondocumentUrl">
                            <img
                              style="cursor: not-allowed"
                              src="assets\images\doc-download-cancel.png"
                              alt="Image"
                              class="image-right"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <mat-card class="doc-card">
                    <div class="incubator-detail-div">
                      <div class="d-flex align-items-center doc-card-cont">
                        <div class="ml-3">
                          <p class="detail-p">Track Record Document</p>
                        </div>
                        <div class="ml-auto" (click)="trackrecDoc()">
                          <div *ngIf="trckrecdocumentUrl">
                            <img
                              src="assets\images\doc-download-image.png"
                              alt="Image"
                              class="image-right"
                            />
                          </div>
                          <div *ngIf="!trckrecdocumentUrl">
                            <img
                              style="cursor: not-allowed"
                              src="assets\images\doc-download-cancel.png"
                              alt="Image"
                              class="image-right"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <mat-card class="doc-card">
                    <div class="incubator-detail-div">
                      <div class="d-flex align-items-center doc-card-cont">
                        <div class="ml-3">
                          <p class="detail-p">Other Relevant Document</p>
                        </div>
                        <div class="ml-auto" (click)="otherrecDoc()">
                          <div *ngIf="otherrecdocumentUrl">
                            <img
                              src="assets\images\doc-download-image.png"
                              alt="Image"
                              class="image-right"
                            />
                          </div>
                          <div *ngIf="!otherrecdocumentUrl">
                            <img
                              style="cursor: not-allowed"
                              src="assets\images\doc-download-cancel.png"
                              alt="Image"
                              class="image-right"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
        <div class="col-12 text-center">
          <button class="intrest-btn" (click)="backBtn()">
            <ion-icon name="arrow-back-outline"></ion-icon> Back
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
<app-footer></app-footer>
